











































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { IFilter, ISorter, ITableConfig } from "@/models/tables";
import { FilterOperators, FilterTypes, Sorters } from "@/data/table";
import { WalletTransactionTypes } from "@/models/wallets";
import { IAccount } from "@/models/accounts";

@Component
export default class WalletTransactionsTable extends Mixins(
  FilteringSortingTableStore,
  CurrenciesStore
) {
  @Prop({ default: null })
  public accountId!: IAccount["id"];
  public dataModule = DataModules.WALLETS;
  public canSeeTransactions = this.$userCan("wallet_admin_get_transactions");
  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.date_created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "id",
      label: this.$t("_.date_created")
    },
    {
      field: "amount",
      label: this.$t("_.amount")
    }
  ];
  public apiProps = { with: "currency" };

  public defaults: ITableConfig = {
    sort: {
      field: "id",
      direction: Sorters.DESCENDING
    }
  };

  public async created() {
    if (this.canSeeTransactions) {
      this.getData();
    }
  }

  public getTransactionType(type: WalletTransactionTypes) {
    switch (type) {
      case WalletTransactionTypes.ADD:
        return this.$t("_.add");
      case WalletTransactionTypes.SPEND:
        return this.$t("_.spend");
      case WalletTransactionTypes.REFUND_TO_WALLET:
        return this.$t("_.refund_to_wallet");
      case WalletTransactionTypes.REFUND_TO_GATEWAY:
        return this.$t("_.refund_to_gateway");
      case WalletTransactionTypes.WITHDRAW:
        return this.$t("_.withdraw");
      case WalletTransactionTypes.OVERPAID_CREDIT_NOTE:
        return this.$t("_.overpaid_credit_note");
      case WalletTransactionTypes.REFUND_FROM_WALLET:
        return this.$t("_.refund_from_wallet");
      default:
        return "--";
    }
  }

  @Watch("currenciesLoaded")
  public setCurrenciesFilter() {
    const currenciesOptions = this.currencies.map(currency => ({
      value: currency.id,
      label: currency.name
    }));
    this.filters.push({
      key: "currency_id",
      label: this.$t("_.currency"),
      type: FilterTypes.SELECT,
      options: currenciesOptions,
      operator: FilterOperators.EQUAL
    });
  }

  public openTransactionModal(transaction) {
    this.$store.dispatch(`data/${DataModules.PAYMENTS}/openTransactionModal`, {
      props: {
        transaction: this.$_.omitBy(transaction, (value, key) => {
          const omit = ["brand", "currency"];
          if (omit.includes(key)) return true;
          if (key.startsWith("_")) return true;
          return false;
        })
      }
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
  }

  public storeGetData(params: any) {
    return this.$store.dispatch(`data/${this.dataModule}/transactionsList`, {
      accountId: this.accountId,
      ...params
    });
  }
}
